import axios from "@/utils/axios"
import { create } from "zustand"

type States = {
}
type Actions = {
   
    createQuery: (doc: IQuery) => Promise<IResponse>
   
}
interface IQuery{
    email:string
}

interface IObj {
    [key: string]: any
}

interface IResponse {
    status: boolean
    data?: any
    error?: string
    message?: string
}


const useQueryStore = create<States & Actions>((set) => ({
 
    createQuery: async (doc: IQuery) => {
        try {
            const result = await axios.post(process.env.NEXT_PUBLIC_BOOKING_SERVICE + `/query/create`, doc);
            if (result?.data?.status) {
                return { status: true, data: result.data?.data,message:result.data?.message };
            } else {
                return { status: false, error: result.data?.error || "Something went wrong" };
            }
        } catch (error: any) {
            return { status: false, error: error?.message || "Something went wrong" };
        }
    },
   
}))
export default useQueryStore
